import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export function DashboardRedirect() {
  const { isSpedflowAdmin, isTenantAdmin, isAdvocate, isClient, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  // Redirect based on role
  if (isSpedflowAdmin) {
    return <Navigate to="/admin/dashboard" replace />;
  }
  if (isTenantAdmin) {
    return <Navigate to="/tenant/dashboard" replace />;
  }
  if (isAdvocate) {
    return <Navigate to="/advocate/dashboard" replace />;
  }
  if (isClient) {
    return <Navigate to="/portal/dashboard" replace />;
  }

  // Fallback
  return <Navigate to="/login" replace />;
}
